// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9467) return "static/chunks/9467-c97a9e7dc2e2f5ae.js";
	if (chunkId === 7988) return "static/chunks/7988-a4f63ea2d77eed67.js";
	if (chunkId === 1397) return "static/chunks/1397-8ea630dbd0f147aa.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2006":"97707ab7f4c9f3f1","5496":"4d6c86bda152fb14","5525":"0e44f6714ac3b3e5"}[chunkId] + ".js";
};